/** Extrai mensagem amigável do body JSON de erro da API (ex.: { error: "..." }). */
export function messageFromApiErrorBody(data) {
    if (!data || typeof data !== 'object') return '';
    if (typeof data.error === 'string' && data.error.trim()) return data.error;
    if (typeof data.message === 'string' && data.message.trim()) return data.message;
    if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
    if (Array.isArray(data.detail)) {
        const parts = data.detail.map((d) => (typeof d === 'string' ? d : d?.msg)).filter(Boolean);
        if (parts.length) return parts.join(', ');
    }
    return '';
}
